import useExchangeRate from '@/utils/hooks/useExchangeRate'
import { formatUsdPer } from '@/utils/format-usd'

const getSatoshiPriceUSD = (satoshiPrice: number | bigint, exchangeRate: number) => {
	let satoshis
	if (typeof satoshiPrice === 'bigint') {
		// TODO double check this
		satoshis = Number((satoshiPrice * BigInt(1000000)) / BigInt(1e8)) / 1000000
	} else {
		satoshis = satoshiPrice / 1e8
	}

	const { usd } = formatUsdPer(satoshis * exchangeRate)

	return usd.toLocaleString('en-US', {
		maximumFractionDigits: 2,
		minimumFractionDigits: 2
	})
}

const useSatoshiPriceUSD = (satoshiPrice: number | bigint): [string, boolean] => {
	const { exchangeRate, isLoading: loadingRate } = useExchangeRate()

	const price = getSatoshiPriceUSD(satoshiPrice, exchangeRate)

	return [price, satoshiPrice ? loadingRate : true]
}

export { useSatoshiPriceUSD as default, getSatoshiPriceUSD }
